import {useRef} from 'react';
import {useSelector} from 'react-redux';
import cx from 'classnames';
import {useInMwEditDesignButtonAbTest} from '~/common/hooks/useInMwEditDesignButtonAbTest';
import {Card} from '~/common/canvas/Card/Card';
import {selectFabricArt} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';
import {useEnvelope} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Envelope/actions/useEnvelope';
import {Envelope} from '~/common/fabric/Card/components/Envelope/Envelope';
import {Sections} from '~/CreateFabricInvitation/routes/EventCreateDesign/constants';
import {useIsLargishAndUp} from '~/common/hooks/useMatchQuery';
import {selectIsGuestsFabricGreetingCard} from '~/common/fabric/EventGuests/reducers/guests/selectors';

import './Background.sass';

export const Background = () => {
  const ref = useRef();
  const fabricArt = useSelector(selectFabricArt);
  const fabricGreetingCard = useSelector(selectIsGuestsFabricGreetingCard);
  const {selectedEnvelope: envelope} = useEnvelope();
  const isLargishAndUp = useIsLargishAndUp();
  const isInEditButtonTest = useInMwEditDesignButtonAbTest();

  if (!envelope) {
    return null;
  }

  const type =
    envelope.flap_down_image && (fabricGreetingCard || isLargishAndUp)
      ? 'flap_down_image'
      : 'blank';

  return (
    <div
      className={cx('card-template create_flow__background', {
        'onestep-edit-ABTest__card-wrapper': isInEditButtonTest,
      })}
    >
      <div className="create_flow__background__images">
        <Envelope
          type={type}
          className="card-template__envelope"
          redirectTo={isLargishAndUp ? Sections.ENVELOPE_LINER : null}
          forceShowEnvelope
        />
        <Card
          className="create_flow__background__images__card"
          fabricArt={fabricArt}
          redirectTo={Sections.CARD_DESIGN}
          imageRef={ref}
          parentNode={`${!isLargishAndUp ? 'create-container' : ''}`}
        />
      </div>
    </div>
  );
};
